import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddDiagnosticComponent } from './add-diagnostic/add-diagnostic.component';
import { AssignDiagnosticComponent } from './assign-diagnostic/assign-diagnostic.component';

const routes: Routes = [
  {path: 'add-diagnostic', component:AddDiagnosticComponent},
  {path: 'assign-diagnostic', component:AssignDiagnosticComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiagnosticRoutingModule { }
